module.exports = __webpack_public_path__ + "img/dynamic-6.7bb554ed.png";